import React from 'react'
import Tooltip from './Tooltip'

const HelpIcon = ({ tooltip }: { tooltip?: string }) => {
  return tooltip ? (
    <Tooltip label={tooltip}>
      <div className="flex items-center justify-center rounded-full border border-black dark:border-white cursor-pointer w-[15px] h-[15px]">
        <span className="text-xs font-bold">?</span>
      </div>
    </Tooltip>
  ) : (
    <div className="flex items-center justify-center rounded-full border border-black dark:border-white cursor-pointer w-[15px] h-[15px]">
      <span className="text-xs font-bold">?</span>
    </div>
  )
}

export default HelpIcon
